import React, { Component } from 'react';

class ServicesConsultancy extends Component {
    
    render() {
      return (
        <React.Fragment>
            <p id="title">Consultancy Services</p>
            
            <p>
                We try our best to provide our client with the solutions for durable and joyful life time in their properties: 
            </p>
            <ul>
                
                <li>
                    Power consumption reduction
                </li>
                <li>
                    Long term plumbing solutions
                </li>
                <li>
                    Smart home automation 
                </li>
                <li>
                    Landscaping enhancement 
                </li>
            </ul>

        </React.Fragment>
      );
   }
}

export default ServicesConsultancy;